import React from "react";
import FLoGo from "../../images/logo.svg";
import "./Footer.css";

// images

const Footer = (props) => {
  return (
    <footer className={"custom-footer " + props.hclass}>
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <h2 className="footer-phone">032-435-9323</h2>
            <div className="footer-info">
              <p>상담시간 9:00~17:00</p>
              <p>점심시간 12:00~13:00</p>
              <p>주말 및 공휴일 휴무</p>
            </div>
            <div className="footer-contact">
              <p style={{ color: "#FFF" }}>개인정보처리방침</p>
              <p>FAX : 032-435-9325</p>
              <p>MAIL : mrmtl2012@daum.net</p>
              <p>홈페이지 : mrlo@mrlo.co.kr</p>
            </div>
          </div>
          <div className="footer-right">
            <p>(주)엠알메탈로</p>
            <p>본점: 인천시 남동구 앵고개로 719번길 89(고잔동)</p>
            <p>지점(1공장): 인천시 남동구 앵고개로 719번길 84(고잔동)</p>
            <p>예산지점(2공장): 충청남도 예산군 신암면 용산로 82-17</p>
            <p>COPYRIGHTⒸ2025 by MRMETALLO.CO.LTD. ALL RIGHTS RESERVED</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
